
/**
 * Utility to generate SHA-256 hashes for files and strings.
 * Used for upload deduplication and cache integrity checks.
 */
export async function computeHash(data: string | Blob | ArrayBuffer): Promise<string> {
  const buffer = typeof data === 'string' 
    ? new TextEncoder().encode(data) 
    : data instanceof Blob 
      ? await data.arrayBuffer() 
      : data;

  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}
